import type { FC } from 'react'
import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import DeepenYourUnderstandingPng2x from './assets/DeepenYourUnderstanding@2x.png'
import DeepenYourUnderstandingWebp from './assets/DeepenYourUnderstanding.webp'
import DeepenYourUnderstandingWebp2x from './assets/DeepenYourUnderstanding@2x.webp'

const copy = {
  heading: `Deepen your understanding of each customer with contextualized customer data`,
  description: `Segment CDP provides the trusted, AI-ready data foundation needed to power intelligent customer engagement and inform every LLM interaction with relevant information about each individual customer.`,
}

const DeepenYourUnderstanding: FC = () => {
  return (
    <SectionBase variant="2Col">
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>

          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </SectionCopy>

      <Section.Contents>
        <picture>
          <source type="image/webp" srcSet={`${DeepenYourUnderstandingWebp}, ${DeepenYourUnderstandingWebp2x} 2x`} />
          <Image
            src={DeepenYourUnderstandingPng2x}
            alt="Illustration: Deepen Your Understanding"
            width="600"
            height="450"
            loading="lazy"
          />
        </picture>
      </Section.Contents>
    </SectionBase>
  )
}

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`

export default DeepenYourUnderstanding
